if (!customElements.get('app-banner')) {
  customElements.define(
    'app-banner',
    class AppBanner extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.boundInit, { once: true });
          return;
        }
        this.initialize();
      }

      boundInit() {
        this.initialize();
      }

      initialize() {
        const userAgent = navigator.userAgent;
        this.isAndroid = /Android/i.test(userAgent) && /Mobi/i.test(userAgent);

        this.hideBanner = this.isBannerHidden();

        if (!this.isAndroid || this.hideBanner) {
          document.querySelector('.app__banner-section')?.remove();
          return;
        }

        this.createBanner();
      }

      isBannerHidden() {
        const bannerStorage = localStorage.getItem('hideAppBanner') || false;
        if (bannerStorage) {
          const today = new Date();
          const hideDate = new Date(bannerStorage);

          const difference = Math.abs(today.getTime() - hideDate.getTime());
          const delay = 72 * 60 * 60 * 1000; // 72 hours in milliseconds

          if (difference < delay) {
            return true;
          } else {
            localStorage.removeItem('hideAppBanner');
            return false;
          }
        }

        return false;
      }

      createBanner() {
        this.favicon = document.querySelector('.app__banner-favicon');
        const fragment = document.createDocumentFragment();
        const banner = document.createElement('div');
        banner.classList.add('app-banner');
        banner.innerHTML = `
          <div class="app-banner__container">
            <div class="app-banner__content">
            <div class="app-banner__copy">
              <button class="app-banner__close">&#10005;</button>
              <div class="app-banner__text">
                <p>Simify eSIMs: Travel Connected</p>
                <p>Open in the Simify app</p>
              </div>
              
            </div>
              <div class="app-banner__logo">
                <a href="intent://simify.com/home/#Intent;scheme=simify;package=com.myshopify.simsdirectus.android;S.browser_fallback_url=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.myshopify.simsdirectus.android;end;">
                  <img src="https://cdn.shopify.com/s/files/1/0582/6081/6062/files/GoogleStore.png?v=1764727459" alt="Download on Google Play" class="app-banner__image" height="142" width="" />
                </a>
              </div>
            </div>
        </div>`;

        fragment.appendChild(banner);
        this.appendChild(fragment);
        const parentNode = this.querySelector('.app-banner__copy');
        const referenceNode = this.querySelector('.app-banner__text');

        if (!parentNode || !referenceNode) return;

        parentNode.insertBefore(this.favicon, referenceNode);

        this.favicon.classList.remove('hidden');
        setHeaderPosition();

        this.closeBtn = this.querySelector('.app-banner__close');
        this.closeBtn?.addEventListener('click', this.closeBanner.bind(this));
      }

      closeBanner() {
        this.remove();
        setHeaderPosition();
        localStorage.setItem('hideAppBanner', new Date());
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.boundInit);
        this.closeBtn?.removeEventListener('click', this.closeBanner.bind(this));
      }
    },
  );
}
